export const environment = {     
  production: true,
  baseUrl:"https://kachiing.com/",
  baseUrlAdmin: "https://api.kachiing.com/adminApp/",
  ImageUrl: "https://api.kachiing.com/",
  // baseUrlAdmin: "http://localhost:3016/adminApp/",
  // ImageUrl: "http://localhost:3016/",
  paypalClientId: "ASkeUiOmMALMGIDu3v3w5-u2dXrq-rH2RDZYgIPfKuSx7LaTSG9NIvzbiNTzYzfoF893zDylJEgH2O02",
  paypalPlanId: "P-4J20613518231261SMHJI7KQ",
 whtsappCloudUrl: "https://graph.facebook.com/v15.0/106218345699617/messages",
  whtsappCloudToken:
    "EAAHMiNKkKV4BANnUGqjn8f7rtPSI8w2mdlCZBW2ZAZBXIrZCNiFKNmsLqDI9t9vzMKcZAtuVKhVBFdsq0xtBc4Hnm9nHREyiNXy8ukoElBBGe0G8u1HAPM5Hp3Gsl1920pZCYDPfxUj33BRCXEPiq6dRMVIkmvHF2XXfQewTaT3D6sqqH07gZAehVYJsfKjFZA4EqOgW5CMLYAZDZD",
  sendbirdAppId: "85C89A6D-A35C-4986-A71A-A8495A5090EE",
    sendbirdAccessTokenAIBot: "6a028767ccb80bd27c718bcc0ebf5d6089b5393b",
     chatSocketServer: 'https://api.kachiing.com/socket.io'


};

// export const environment = {
//   production: true,
//    baseUrlAdmin: "http://192.168.1.128:3011/adminApp/",
//   ImageUrl: "http://192.168.1.128:3011/"
// };
